<template>
  <div class="form-group row no-gutters editor-popover-datarow">
    <label class="col-form-label col-sm-4">{{label}}</label>
    <div class="col-form-label editor-popover-datafield col-sm-8 px-1"><slot /></div>
  </div>
</template>

<style lang="scss" scoped>
$datarow-padding: 3px;

.editor-popover-datarow {
  margin-bottom: 2px;
}
.editor-popover-datarow > label.col-form-label {
  padding-top: $datarow-padding;
  padding-bottom: $datarow-padding;
}
.editor-popover-datafield {
  border: 1px solid #d8dfe6;
  background-color: #f5f5f5;
  color: #828688;
  padding-top: $datarow-padding;
  padding-bottom: $datarow-padding;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.theme-dark .editor-popover-datafield {
  background-color: #474747;
  color: #d7d7d7;
  border-color: #303030;
}
</style>

<script>
export default {
  name: 'EditorPopoverDataRow',
  props: {
    label: String
  }
}
</script>